// Componente para mostrar una fila de íconos de dispositivos en grupos
// con feedback visual en tiempo real
import React from 'react';
import { Box } from '@mui/material';

interface GroupIconsRowProps {
  groupType: 'relay' | 'cover' | 'pulsador';
  deviceCount: number;
  confirmedDeviceIds?: number[];
}

const GroupIconsRow: React.FC<GroupIconsRowProps> = ({
  groupType,
  deviceCount,
  confirmedDeviceIds = []
}) => {
  // Determinar el ícono según el tipo de grupo
  const getIcon = () => {
    switch (groupType) {
      case 'relay':
        return '💡'; // Lamparita
      case 'cover':
        return '📜'; // Persiana
      case 'pulsador':
        return '🔘'; // Botón
      default:
        return '⚪';
    }
  };

  const icon = getIcon();

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        padding: 1,
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 40
      }}
    >
      {Array.from({ length: deviceCount }).map((_, index) => {
        const isConfirmed = confirmedDeviceIds.includes(index);

        return (
          <Box
            key={index}
            sx={{
              fontSize: 20,
              color: isConfirmed ? '#2391FF' : '#fff',
              opacity: isConfirmed ? 1.0 : 0.3,
              transition: 'all 0.3s ease',
              filter: isConfirmed ? 'drop-shadow(0 0 4px #2391FF)' : 'none',
              transform: isConfirmed ? 'scale(1.1)' : 'scale(1)',
              animation: isConfirmed ? 'pulse 0.3s ease-in-out' : 'none'
            }}
          >
            {icon}
          </Box>
        );
      })}

      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.2);
            }
          }
        `}
      </style>
    </Box>
  );
};

export default GroupIconsRow;


